module.exports = __webpack_public_path__ + "img/geo.54a59aae.svg";